export class TimeRecordingFormatterKey {
  static readonly HOURS = 'time-recording/formatter/hours';
}
